let bubbleLocation
let bubbleVehicle
function vueBubbleLocation() {
    bubbleLocation = Vue.createApp({
        delimiters: ['#{', '}'],
        setup() {
            const changeButton = Vue.ref(false)

            const storeSelector = window.storeSelector()

            const bubbleLocationSearch = Vue.ref('')
            const bubbleSuburbs = Vue.ref(false)
            const bubblePostcodes = Vue.ref(false)

            const vehicleSearch = window.vehicleSearch()

            const showStoreList = Vue.ref(false)

            const showSearchBox = () => {
                storeSelector.getLocationInfo().then(([postcodes, suburbs]) => {
                    Vue.watch(bubbleLocationSearch, (newInput, oldInput) => {
                        showStoreList.value = false
                        if (newInput.length < oldInput.length) {
                            bubbleSuburbs.value = false
                            bubblePostcodes.value = false
                        }
                        storeSelector.inputListener(newInput, bubbleSuburbs, bubblePostcodes, postcodes, suburbs)
                    })
                })
            }

            const changeLocButton = () => {
                changeButton.value = true
            }

            const showInput = Vue.computed(() => {
                return !storeSelector?.nearestStore || changeButton.value ? true : false
            })

            const hideResult = Vue.computed(() => {
                return storeSelector?.nearestStore && !changeButton.value ? true : false
            })

            const showSuburbList = Vue.computed(() => {
                return showInput.value && bubbleSuburbs.value ? true : false
            })

            const showPostcodeList = Vue.computed(() => {
                return showInput.value && bubblePostcodes.value ? true : false
            })

            const locationName = Vue.computed(() => {
                return storeSelector.location.name ? storeSelector.location.name : storeSelector.location.postcode ? storeSelector.location.postcode : ''
            })

            const bubbleLocationSelect = (locName, locLat, locLong) => {
                storeSelector.locationSelect(locName, locLat, locLong)
                bubbleSuburbs.value = false
                bubblePostcodes.value = false
                showStoreList.value = true
            }

            const chooseStore = (index) => {
                storeSelector.storeSelect(index)
                vehicleSearch.regoState = storeSelector.storeList[index].node.address.provinceCode.toUpperCase()
                showStoreList.value = false
                changeButton.value = false
                bubbleLocationSearch.value = ''
            }

            Vue.onMounted(() => {
                if (storeSelector?.nearestStore) {
                    changeButton.value = false
                }
            })

            return {
                showInput, bubbleLocationSearch, bubbleSuburbs, bubblePostcodes, showSearchBox, bubbleLocationSelect, hideResult, showPostcodeList, showSuburbList, locationName, changeLocButton, storeSelector, showStoreList, chooseStore
            };
        }
    })
    bubbleLocation.use(window.VueAppGlobals.pinia);
    bubbleLocation.mount('#bubbleLocMount');
}

function vueBubbleVehicle() {
    bubbleVehicle = Vue.createApp({
        delimiters: ['#{', '}'],
        setup() {
            const popup = Vue.ref(false)

            const vehicleLoad = Vue.ref(false)

            const vehicleSearch = window.vehicleSearch()
            const uiState = window.uiState()

            vehicleSearch.loadVehicleArray()

            const vehicle = Vue.ref('')

            const rego = Vue.ref('')
            const sanitizeRegoValue = (value) => {
                return String(value || '')
                    .replace(/\s+/g, '')
                    .replace(/[^a-zA-Z0-9]/g, '')
                    .toUpperCase()
            }

            const regResponse = Vue.ref(false)

            const noRego = Vue.computed(() => {
                return popup.value && !regResponse.value ? true : false
            })

            const yesRego = Vue.computed(() => {
                return popup.value && regResponse.value ? true : false
            })

            const pendingConfirmedVehicle = Vue.ref(null)
            const confirmingVehicle = Vue.ref(false)
            const vehicleReady = Vue.computed(() => {
                if (!vehicle.value?.id) return false
                if (pendingConfirmedVehicle.value && String(pendingConfirmedVehicle.value.id) === String(vehicle.value.id)) {
                    return true
                }
                return vehicleSearch.vehicles.some(v => String(v.id) === String(vehicle.value.id))
            })
            const canConfirmVehicle = Vue.computed(() => {
                return !!pendingConfirmedVehicle.value?.id && !confirmingVehicle.value
            })

            const noRegoInput = Vue.ref(false)

            const noStateInput = Vue.ref(false)
            const regoLookupInFlight = Vue.ref(false)
            Vue.watch(rego, (value) => {
                const cleaned = sanitizeRegoValue(value)
                if (value !== cleaned) {
                    rego.value = cleaned
                    return
                }
                if (cleaned.length > 0) {
                    noRegoInput.value = false
                }
            })


            /*Vue.onMounted(() => {
                vehicleSearch.retrieveSelectorOptions(0)
            })*/

            const tempVehicle = Vue.ref('')
            const pendingPopupFound = Vue.ref(null)
            const modalOwnerId = `ggjb-${Math.random().toString(36).slice(2)}`
            const vehicleDropdownOpen = Vue.computed(() => {
                const value = uiState?.vehicleDropdownOpen
                if (value && typeof value === 'object' && 'value' in value) return !!value.value
                return !!value
            })

            const showPopupNow = (found) => {
                if (window.__ggVehicleModalOpen && window.__ggVehicleModalOpen !== modalOwnerId) {
                    return
                }
                window.__ggVehicleModalOpen = modalOwnerId
                regResponse.value = !!found
                popup.value = true
                uiState?.setVehicleModalOpen?.(true)
            }

            const openPopup = (found) => {
                pendingPopupFound.value = !!found
                uiState?.setVehicleDropdownOpen?.(false)
                const tryOpen = (attempt = 0) => {
                    if (!vehicleDropdownOpen.value || attempt >= 20) {
                        showPopupNow(!!pendingPopupFound.value)
                        pendingPopupFound.value = null
                        return
                    }
                    setTimeout(() => tryOpen(attempt + 1), 25)
                }
                setTimeout(() => tryOpen(0), 0)
            }

            const closePopup = () => {
                popup.value = false
                vehicleLoad.value = false
                uiState?.setVehicleModalOpen?.(false)
                if (window.__ggVehicleModalOpen === modalOwnerId) {
                    window.__ggVehicleModalOpen = null
                }
                retryRego()
            }

            Vue.onUnmounted(() => {
                if (window.__ggVehicleModalOpen === modalOwnerId) {
                    window.__ggVehicleModalOpen = null
                }
            })

            const retryRego = () => {
                pendingConfirmedVehicle.value = null
                vehicleLoad.value = false
                regoLookupInFlight.value = false
                rego.value = ''
                resetRecaptcha()
            }

            const regoSearch = () => {
                if (vehicleLoad.value) {
                    return
                }

                regResponse.value = false
                popup.value = false
                pendingConfirmedVehicle.value = null
                const normalizedRego = sanitizeRegoValue(rego.value)
                rego.value = normalizedRego

                if (normalizedRego.length == 0 || vehicleSearch.regoState.length == 0) {
                    vehicleLoad.value = false
                    if (normalizedRego.length == 0) {
                        noRegoInput.value = true
                    }
                    if (vehicleSearch.regoState.length == 0) {
                        noStateInput.value = true
                    }
                } else {
                    vehicleLoad.value = true
                    regoLookupInFlight.value = true
                    noRegoInput.value = false
                    noStateInput.value = false
                    vehicleSearch.regoLPN = normalizedRego
                    // Force a watcher transition even when the next response is another "regoFail"
                    vehicleSearch.vehicleCall = { status: 'pending', at: Date.now(), source: 'journey-bubbles' }
                    if (vehicleSearch.vehicles.filter((v) => v.rego == normalizedRego && v.regoState == vehicleSearch.regoState).length > 0) {
                        tempVehicle.value = vehicleSearch.vehicles.filter((v) => v.rego == normalizedRego && v.regoState == vehicleSearch.regoState)[0];
                    }
                    if (tempVehicle?.value?.fitmentInfo?.version == vehicleSearch?.releaseVersion && tempVehicle?.value?.fitmentInfo?.expiry > Date.parse(new Date())) {
                        vehicle.value = tempVehicle.value
                        pendingConfirmedVehicle.value = tempVehicle.value
                        openPopup(true)
                        vehicleLoad.value = false
                        regoLookupInFlight.value = false
                        tempVehicle.value = ''
                    } else {
                        try {
                            grecaptcha.execute();
                        } catch (e) {
                            vehicleLoad.value = false
                            regoLookupInFlight.value = false
                        }
                    }
                }
            }

            const vCall = Vue.computed(() => {
                return vehicleSearch.vehicleCall
            })

            Vue.watch(vCall, (newInput) => {
                if (!regoLookupInFlight.value && (!newInput || newInput == 'regoFail')) {
                    return
                }
                if (!regoLookupInFlight.value && !(newInput && typeof newInput === 'object' && newInput.status === 'pending')) {
                    return
                }
                if (newInput && typeof newInput === 'object' && newInput.status === 'pending') {
                    return
                }
                if (newInput == 'regoFail' || !newInput) {
                    pendingConfirmedVehicle.value = null
                    openPopup(false)
                    vehicleLoad.value = false
                    regoLookupInFlight.value = false
                    resetRecaptcha()
                } else {
                    newInput.rego = sanitizeRegoValue(rego.value)
                    newInput.regoState = vehicleSearch.regoState
                    vehicle.value = newInput
                    openPopup(true)
                    vehicleLoad.value = false
                    regoLookupInFlight.value = false
                    vehicleSearch.getFitment(vehicle.value.id)
                        .then(object => {
                            if (object == 'fitFail') {
                                console.log("Failed to retrieve fitment")
                            } else {
                                let fitVehicle = vehicle.value
                                if (!object?.tyre_fitments[0]?.is_oe) {
                                    for (i = 1; i < object.tyre_fitments.length; i++) {
                                        if (object.tyre_fitments[i].is_oe) {
                                            let oeFit = object.tyre_fitments[i]
                                            object.tyre_fitments.splice(i, 1)
                                            object.tyre_fitments.unshift(oeFit)
                                            break
                                        }
                                    }
                                }
                                object.tyre_fitments[0].f_tyres.filters = vehicleSearch.createFitFilters(object.tyre_fitments[0].f_tyres)
                                if (object.tyre_fitments[0].is_split) {
                                    object.tyre_fitments[0].r_tyres.filters = vehicleSearch.createFitFilters(object.tyre_fitments[0].r_tyres)
                                }
                                //move OE wheels to front of array
                                if (!object?.wheel_fitments[0]?.is_oe) {
                                    for (i = 1; i < object.wheel_fitments.length; i++) {
                                        if (object.wheel_fitments[i].is_oe) {
                                            let oeFit = object.wheel_fitments[i]
                                            object.wheel_fitments.splice(i, 1)
                                            object.wheel_fitments.unshift(oeFit)
                                            break
                                        }
                                    }
                                }
                                if (object?.wheel_fitments[0]?.f_wheels?.filters) {
                                    object.wheel_fitments[0].f_wheels.filters = vehicleSearch.createFitFilters(object.wheel_fitments[0].f_wheels)
                                }
                                if (object?.wheel_fitments[0]?.is_split) {
                                    object.wheel_fitments[0].r_wheels.filters = vehicleSearch.createFitFilters(object.wheel_fitments[0].r_wheels)
                                }
                                fitVehicle.fitmentInfo = object
                                fitVehicle.fitmentInfo.version = vehicleSearch.releaseVersion
                                fitVehicle.fitmentInfo.expiry = Date.parse(new Date()) + (24 * (60 * (60 * 1000)))
                                fitVehicle.manufactureYear = vehicleSearch.manYear(vehicle.value)
                                tempVehicle.value = fitVehicle
                                tempVehicle.value.rego = sanitizeRegoValue(rego.value)
                                tempVehicle.value.regoState = vehicleSearch.regoState
                                delete tempVehicle.value.ip
                                pendingConfirmedVehicle.value = tempVehicle.value
                                vehicle.value = tempVehicle.value
                                tempVehicle.value = ''
                            }
                        })
                }
            })

            const vehicleConfirm = async (targetHref = '') => {
                if (confirmingVehicle.value) return
                const confirmedVehicle = pendingConfirmedVehicle.value || null
                if (!confirmedVehicle || !confirmedVehicle.id) return
                confirmingVehicle.value = true

                try {
                    const preIndex = vehicleSearch.vehicles.findIndex(v => String(v.id) === String(confirmedVehicle.id))
                    if (preIndex > -1) {
                        vehicleSearch.vehicles.splice(preIndex, 1)
                    }
                    await vehicleSearch.addVehicle(confirmedVehicle)

                    const storedVehicles = (() => {
                        try { return JSON.parse(localStorage.getItem('vehicles') || '[]') } catch (e) { return [] }
                    })()
                    if (!storedVehicles.some((v) => String(v?.id) === String(confirmedVehicle.id))) {
                        const merged = [confirmedVehicle, ...vehicleSearch.vehicles.filter((v) => String(v?.id) !== String(confirmedVehicle.id))]
                        localStorage.setItem('vehicles', JSON.stringify(merged.slice(0, 3)))
                    }

                    localStorage.setItem('activeVehicleId', String(confirmedVehicle.id))
                    window.dispatchEvent(new CustomEvent('vehicle-updated', { detail: confirmedVehicle }))
                    pendingConfirmedVehicle.value = null
                    closePopup()
                    if (targetHref) {
                        window.location.href = targetHref
                    }
                } finally {
                    confirmingVehicle.value = false
                }
            }

            return {
                vehicleSearch, rego, popup, regoSearch, noRego, closePopup, yesRego, vehicle, noRegoInput, noStateInput, storeSelector, vehicleLoad, vehicleDropdownOpen, vehicleReady, vehicleConfirm, canConfirmVehicle, confirmingVehicle
            };
        }
    })
    bubbleVehicle.use(window.VueAppGlobals.pinia);
    bubbleVehicle.mount('#regoBubble');
}

if (window.Vue && window.Pinia) {
    vueBubbleLocation();
    vueBubbleVehicle();
} else {
    window.addEventListener('vue-ready', function () {
        vueBubbleLocation();
        vueBubbleVehicle();
    });
}
